import axios from "axios";

const historiesUrl = "/api/v1/survivorship_business_rules_histories";

const survivorshipBusinessRulesHistoriesApi = {
  fetchHistories: payload => axios.get(historiesUrl, payload),
};

export default survivorshipBusinessRulesHistoriesApi;
